import axios from "axios";
import { createAuthenticatedAxiosInstance } from "../auth/auth.slice";

const baseUrl = import.meta.env.VITE_API_URL;

export const rolesService = {
    getAllRoles: async () => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.get(`${baseUrl}roles`);
        return response.data;
    },

    createRole: async (roleData) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.post(`${baseUrl}roles`, roleData);
        return response.data;
    },

    updateRole: async (id, roleData) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.put(`${baseUrl}roles/${id}`, roleData);
        return response.data;
    },

    deleteRole: async (id) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.delete(`${baseUrl}roles/${id}`);
        return response.data;
    },
};
